module.exports = __webpack_public_path__ + "static/hotsnail-services-5efdca7b4f20d95f63bb4e265e8a6d21.jpg";